/**
 * O interruptor "Mostrar IDs" (EL-045) — de volta, agora na casca.
 *
 * POR QUE ELE EXISTE, e por que não é enfeite de desenvolvedor
 * Todo elemento do Fincast tem um ID estável (EL-001, EL-002, …) atribuído uma vez e
 * nunca reaproveitado. É assim que o produto é conversado: "EL-018: faça X" vai direto ao
 * ponto, enquanto "aquele card do meio" muda de nome entre versões e gera atrito. Sem as
 * etiquetas na tela, quem pede a mudança não tem como apontar.
 *
 * Ele morava na barra lateral da v67, que o porte descartou junto com a casca antiga.
 * Voltou aqui, e só para o **Admin Hype**: para o gestor de uma incorporadora as etiquetas
 * seriam ruído sobre uma tela que ele não vai me pedir para mudar. Só o interruptor E o
 * efeito: quem não é admin nunca vê etiqueta, mesmo com a preferência do admin gravada no
 * mesmo navegador (`aplicarIdsDoPerfil`, 09/10/2026).
 *
 * A marcação da v67 já traz as etiquetas prontas (`<span class="elb">`). As telas da casca
 * trazem só `data-el`, e é `marcarIds` quem lhes põe a etiqueta — assim uma tela nova
 * ganha o ID visível só por declarar o atributo, sem ninguém lembrar de nada.
 */
const CHAVE = 'fincastMostrarIds';

export function idsVisiveis(): boolean {
  return document.body.classList.contains('ids');
}

export function definirIds(mostrar: boolean): void {
  document.body.classList.toggle('ids', mostrar);
  try {
    localStorage.setItem(CHAVE, mostrar ? '1' : '0');
  } catch {
    /* armazenamento bloqueado: vale só nesta aba */
  }
}

export function iniciarIds(): void {
  let salvo: string | null = null;
  try {
    salvo = localStorage.getItem(CHAVE);
  } catch {
    salvo = null;
  }
  document.body.classList.toggle('ids', salvo === '1');
}

/**
 * A preferência vale só para quem pode mexer nela — o Admin Hype (09/10/2026).
 *
 * O VAZAMENTO que isto fecha: a preferência mora no `localStorage`, que é do NAVEGADOR e não
 * da pessoa. `iniciarIds()` roda no arranque para qualquer um, então o admin ligava as
 * etiquetas, saía, e quem entrasse depois na mesma máquina via as etiquetas EL-xxx da v67
 * (que vêm prontas na marcação do simulador) — sem interruptor nenhum para desligá-las.
 *
 * Quem não é admin: a classe sai, e a preferência FICA (ela é do admin, não de quem está
 * aqui agora). O admin: reaplica a preferência — sem isto, na sequência admin → outro →
 * admin na mesma aba, o interruptor nasceria desmarcado com a preferência ligada.
 * Chamada pela casca ao nascer, ANTES do interruptor, que lê o estado do `<body>`.
 */
export function aplicarIdsDoPerfil(isAdminHype: boolean): void {
  if (isAdminHype) iniciarIds();
  else document.body.classList.remove('ids');
}

/**
 * Põe a etiqueta visível em tudo que declara `data-el` e ainda não tem uma.
 *
 * A etiqueta é `position:absolute`, então o elemento precisa de `.elh`
 * (`position:relative`) para ela se ancorar nele, e não num avô qualquer.
 */
export function marcarIds(raiz: ParentNode): void {
  for (const el of raiz.querySelectorAll<HTMLElement>('[data-el]')) {
    /* A PRÓPRIA ETIQUETA carrega `data-el` — tanto a que eu crio quanto a que veio da
       v67. Sem esta linha, a passagem seguinte encontra a etiqueta, trata-a como elemento
       a marcar e injeta outra DENTRO dela: o texto vira "EL-172EL-172". Passou pela
       primeira verificação de duplicata porque aquela só olhava filhos diretos do
       elemento, e etiqueta-dentro-de-etiqueta é um filho só. */
    if (el.classList.contains('elb')) continue;
    const id = el.getAttribute('data-el');
    if (id === null || id === '') continue;
    /* A marcação vinda da v67 já traz a etiqueta pronta; não duplicar. */
    if (el.querySelector(':scope > .elb') !== null) continue;
    el.classList.add('elh');
    const etiqueta = document.createElement('span');
    etiqueta.className = 'elb';
    etiqueta.setAttribute('data-el', id);
    etiqueta.textContent = id;
    el.insertBefore(etiqueta, el.firstChild);
  }
}
